module.exports = [
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/02-5a18615cd4.jpg",
		"text": "Office @ Buenos Aires",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/03-54a800bd8d.jpg",
		"text": "Offsite @ Cancún",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/04-20284e280f.jpg",
		"text": "Offsite @ Cancún",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/05-6ca39bd7a7.jpg",
		"text": "Offsite @ Cancún",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/06-0429ebc8cd.jpg",
		"text": "Offsite @ Uruguay",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/07-ae9ad04ba4.jpg",
		"text": "Offsite @ Cancún",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/08-d40701ee5b.jpg",
		"text": "Offsite @ Cancún",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/09-9d71a30911.jpg",
		"text": "Offsite @ Cancún",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/10-21b885a89e.jpg",
		"text": "Offsite @ Cancún",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/11-ff86a2db08.jpg",
		"text": "Office @ Buenos Aires",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/12-67ae59c77c.jpg",
		"text": "Offsite @ Semiahmoo",
		"date": "2016"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/13-4270acbf73.jpg",
		"text": "Offsite @ Cancún",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/14-4a2e68f92b.jpg",
		"text": "Offsite @ Uruguay",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/15-8eb742ab9f.jpg",
		"text": "Office @ Buenos Aires",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/16-7e15551258.jpg",
		"text": "Offsite @ Cancún",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/17-28288b6362.jpg",
		"text": "Offsite @ Cancún",
		"date": "2017"
	},
	{
		"img": "https://cdn.auth0.com/website/assets/pages/about/img/join-us-pictures/18-68d0eb7042.jpg",
		"text": "Offsite @ Cancún",
		"date": "2017"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/data/join-us-pictures.json
// module id = 1352
// module chunks = 0